import React from 'react';

const LookerLoadingSpinner = () => (
  <div>
    <i className="fa fa-circle-notch fa-spin" /> Checking recent ZenDesk Tickets...
  </div>
);

export default LookerLoadingSpinner;